import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Handle Vite build updates / stale asset load failures automatically after deployment
window.addEventListener("vite:preload-error", (event) => {
  console.warn("New deployment detected or asset failed to load. Reloading page...");
  window.location.reload();
});

// Monkeypatch fetch globally to bypass ngrok warning screen for all api requests
const originalFetch = window.fetch;
window.fetch = async function (input, init) {
  const url = typeof input === "string" 
    ? input 
    : (input instanceof URL 
        ? input.toString() 
        : (input instanceof Request ? input.url : ""));

  if (url.includes("ngrok-free.app") || url.includes("ngrok.io")) {
    if (typeof input === "string" || input instanceof URL) {
      init = init || {};
      const headers = new Headers(init.headers);
      headers.set("ngrok-skip-browser-warning", "true");
      init.headers = headers;
    } else if (input instanceof Request) {
      try {
        input.headers.set("ngrok-skip-browser-warning", "true");
      } catch (e) {
        const newHeaders = new Headers(input.headers);
        newHeaders.set("ngrok-skip-browser-warning", "true");
        input = new Request(input, { headers: newHeaders });
      }
    }
  }
  return originalFetch(input, init);
};

createRoot(document.getElementById("root")!).render(<App />);

